import Box from "@memorang/ui/components/Box";
import { ActivityLogListItem } from "@memorang/ui/components/Cme/ActivityLogListItem";
import Container from "@memorang/ui/components/Container";
import { mockActivityLog } from "../constants";

export const CMEActivityLogContainer = () => {
	return (
		<Container maxWidth="sm">
			<Box>
				{mockActivityLog.map((item, index) => (
					<ActivityLogListItem
						key={`${item.title}-${index}`}
						item={item}
						onPress={() => {
							//TODO: handle onPress
						}}
					/>
				))}
			</Box>
		</Container>
	);
};
